import { apiGet, apiPut, apiDelete } from "../client";
import type {
	DashboardLayoutResponseApi,
	SaveDashboardLayoutRequestApi,
} from "../models/dashboardLayout";

export async function getDashboardLayout(
	roleId: number,
): Promise<DashboardLayoutResponseApi> {
	return apiGet<DashboardLayoutResponseApi>(`dashboards/layout/${roleId}`);
}

export async function saveDashboardLayout(
	roleId: number,
	request: SaveDashboardLayoutRequestApi,
): Promise<void> {
	return apiPut<void>(`dashboards/layout/${roleId}`, request);
}

export async function deleteDashboardLayout(
	roleId: number,
): Promise<void> {
	return apiDelete<void>(`dashboards/layout/${roleId}`);
}
